import React from 'react'
import styles from './DrawerItem.module.css'

type DrawerItemProps = {
    title: string;
    active: boolean;
    icon: string;
    onClick: () => void;
};

const iconSrc = (path: string) => path.startsWith('http') || path.startsWith('/') ? path : `/${path}`;

const DrawerItem = ({ title, active, icon, onClick }: DrawerItemProps) => {
  const maskUrl = `url("${iconSrc(icon)}")`;

  return (
    <button
      type="button"
      className={`${styles.container} ${active ? styles.active : ''}`}
      onClick={onClick}
      aria-current={active ? 'page' : undefined}
    >
        <div className={styles.icon}>
            <span
              className={styles.iconGraphic}
              aria-hidden
              style={
                {
                  WebkitMaskImage: maskUrl,
                  maskImage: maskUrl,
                } as React.CSSProperties
              }
            />
        </div>
        <span className={styles.title}>{title}</span>
    </button>
    );
};

export default DrawerItem;